<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card class="pa-3">
          <v-layout row wrap>
            <v-flex md3 class="pl-1">
              <v-menu
                v-model="invoiceDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="reportFilters.date"
                    label="Date from"
                    readonly
                    outline
                    required
                    :rules="requiredRules"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="reportFilters.date"
                  @input="invoiceDateMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex md3 class="pl-1">
              <v-menu
                v-model="invoiceDateMenu2"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="reportFilters.date2"
                    label="Date To"
                    readonly
                    outline
                    required
                    :rules="requiredRules"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :min="reportFilters.date"
                  v-model="reportFilters.date2"
                  @input="invoiceDateMenu2 = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex md6 class="text-xs-right">
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    color="primary"
                    fab
                    small
                    dark
                    @click="isSearchModal = true"
                  >
                    <v-icon>search</v-icon>
                  </v-btn>
                </template>
                <span>Advance Search</span>
              </v-tooltip>
            </v-flex>
          </v-layout>

          <ListLoader v-if="isLoadingContent"></ListLoader>
          <div class="simple-table-container" id="invoice-dues-report" v-else>
            <div class="hidden-screen-only report-header text-center">
              <div class="head">
                {{ settings && settings.company_name }}
              </div>
              <div class="address">
                {{ settings && settings.company_address }}
              </div>
              <hr />
              <br />
              <div class="title">
              Project report - 
                {{
                  reportFilters.date == reportFilters.date2
                    ? reportFilters.date
                    : `${reportFilters.date} to ${reportFilters.date2}`
                }}
              </div>
            </div>
            <table class="table table-bordered">
              <tr>
                <th>Contract Date</th>
                <th>Owner</th>
                <th>Name</th>
                <th>Passport</th>
                <th>Mobile</th>
                <th>Agent Name</th>
                <th>Agent Mobile</th>
                <th>Service Charge</th>
                <th>Over income</th>
                <th>Dues</th>
              </tr>
              <tr v-for="item in reportData" :key="item.id">
                <td>{{ item.contract_date }}</td>
                <td>{{ projectOwner(item.project_owner) }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.passport_number }}</td>
                <td>{{ item.mobile }}</td>
                <td>{{ item.agents___name }}</td>
                <td>{{ item.agents___mobile }}</td>
                <td>{{ item.service_charge }}</td>
                <td>{{ overIncome(item) }}</td>
                <td>{{ item.dues }}</td>
              </tr>
              <tr>
                <td colspan="7">
                  <span v-for="c in ownersCounts" :key="c.value" style="margin: 0 15px"
                    >{{ c.text }}: <strong>{{ c.count }}</strong></span
                  >
                </td>
                <td>
                  <strong>{{ serviceChargeSum }}</strong>
                </td>
                <td>
                  <strong>{{ overIncomeSum }}</strong>
                </td>
                <td>
                  <strong>{{ dueSum }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="10" class="report-sum text-center">
                  Total Dues &nbsp;&nbsp; tk. {{ dueSum }}
                </td>
              </tr>
            </table>
          </div>
          <v-card-actions>
            <v-btn flat @click="print()">Print</v-btn>
            <!-- <v-btn flat >Explore</v-btn> -->
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="isSearchModal" scrollable persistent max-width="500px">
      <AdvanceSearch
        :rfilters="reportFilters"
        :hide="['date', 'date2', 'account_head', 'investor', 'passport']"
        @cancelled="isSearchModal = false"
      />
    </v-dialog>
  </div>
</template>

<script>
import { ContentLoader, ListLoader } from "vue-content-loader";
import AdvanceSearch from "../SearchModal";
import { columnSum, valueToText } from "../../mdsir/MdsirUtils";
import { PROJECT_OWNER, MYSQL_DATE_FORMAT } from "../../mdsir/const";
import * as _ from "underscore";

export default {
  components: {
    ContentLoader,
    ListLoader,
    AdvanceSearch,
  },
  data: () => ({
    isSearchModal: false,
    isLoadingContent: false,
    invoiceDateMenu: false,
    invoiceDateMenu2: false,
    reportFilters: {
      date: null,
      date2: null,
    },
    data: [],
  }),

  computed: {
    reportData() {
      return this.data.map(r => ({over_income: this.overIncome(r), ...r}));
    },
    dueSum() {
      return columnSum(this.reportData, "dues");
    },
    serviceChargeSum() {
      return columnSum(this.reportData, "service_charge");
    },
    baseServiceChargeSum() {
      return columnSum(this.reportData, "base_service_charge");
    },
    overIncomeSum() {
      return columnSum(this.reportData, "over_income");
    },
    ownersGroup() {
      return _.groupBy(this.reportData, "project_owner");
    },
    ownersCounts() {
      return PROJECT_OWNER.map((r) => {
        const count = this.ownersGroup.hasOwnProperty(r.value)
          ? this.ownersGroup[r.value].length
          : 0;
        return { count, ...r };
      });
    },
  },

  watch: {
    reportFilters: {
      handler: function (val, oldVal) {
        this.getDataFromApi();
      },
      deep: true,
    },
  },

  created() {},

  mounted() {
    this.reportFilters.date = this.$moment().startOf("month").format(MYSQL_DATE_FORMAT);
    this.reportFilters.date2 = this.$moment().endOf("month").format(MYSQL_DATE_FORMAT);
    this.getDataFromApi();
  },

  methods: {
    getDataFromApi() {
      this.isLoadingContent = true;
      this.get("/project_dues_report", {
        payment_status: "all",
        ...this.reportFilters,
      }).then((response) => {
        this.data = response.data;
        this.isLoadingContent = false;
      });
    },
    print() {
      this.$htmlToPaper("invoice-dues-report");
    },
    projectOwner(value) {
      return valueToText(PROJECT_OWNER, value);
    },
    overIncome(item) {
      return item.base_service_charge && item.base_service_charge > 0 ? item.service_charge - item.base_service_charge : 0;
    },
  },

  beforeDestroy() {},
};
</script>

<style scoped>
.simple-table-container {
  overflow: auto;
}
.table {
  border-collapse: collapse;
  width: 100%;
}
.table th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #bebebe;
}

.table td,
.table th {
  border: 1px solid #ddd;
  padding: 8px;
}

.table td.report-sum {
  padding: 6px;
  text-align: center;
  background-color: #0f0f0f0e;
  font-size: 20px;
  font-weight: bold;
}
</style>
